import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { EVENT } from "@talsho/types";
import { useState } from "react";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Alert from "../../../../components/alert";
import firebaseApp from "../../../../firebase";
import Routes from "../../../../utils/routes";
import EventForm, { OnSaveEventProps } from "../../../../components/eventForm";
import styles from "./styles.module.css";
import { useEventMutations } from "../../hooks";
import { getFirebaseTimestamp } from "../../../../utils/common";
import moment from "moment";

const EditEvent = () => {
  const { id } = useParams<{ id: string }>();
  const [eventData, setEventData] = useState<EVENT>();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const history = useHistory();
  const [editloading, setEditLoading] = useState(false);
  const [eventWinnerLoading, setEventWinnerLoading] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const { uploadEventImage, editEvent, updateEventWinners } =
    useEventMutations();

  useEffect(() => {
    setLoading(true);
    const eventSubscribe = firebaseApp
      .firestore()
      .collection("events")
      .doc(id)
      .onSnapshot(
        (eventDoc) => {
          if (eventDoc.exists) {
            setEventData({
              id: eventDoc.id,
              ...eventDoc.data(),
            } as EVENT);
            setErrorMessage("");
          } else {
            setEventData(undefined);
            setErrorMessage("Event does not exists");
          }
          setLoading(false);
        },
        (error) => {
          setErrorMessage(error.message);
          setLoading(false);
        }
      );
    return () => eventSubscribe();
  }, [id]);

  if (loading) {
    return (
      <Grid container justifyContent="center">
        <CircularProgress />
      </Grid>
    );
  }

  const onSubmit = async ({ event, updatedPoster }: OnSaveEventProps) => {
    try {
      setEditLoading(true);
      if (updatedPoster) {
        const posterUrl = await uploadEventImage(
          updatedPoster.base64,
          event.id
        );
        const eventData = {
          ...event,
          poster: { src: posterUrl, title: updatedPoster.fileName },
          lastUpdate: getFirebaseTimestamp(moment().toDate()),
        } as EVENT;
        await editEvent(eventData);
        history.push(Routes.EVENT + "/" + eventData.id);
      } else {
        const eventData = {
          ...event,
          lastUpdate: getFirebaseTimestamp(moment().toDate()),
        } as EVENT;
        await editEvent(eventData);
        history.push(Routes.EVENT + "/" + eventData.id);
      }
      setEditLoading(false);
    } catch (error) {
      setErrorMessage(error.message);
      setEditLoading(false);
    }
  };

  const onWinners = async () => {
    try {
      setEventWinnerLoading(true);
      if (eventData) {
        await updateEventWinners(eventData);
        setShowMessage("Winners Updated");
      } else {
        throw new Error("Event does not exist");
      }
      setEventWinnerLoading(false);
    } catch (error) {
      setErrorMessage(error.message);
      setEventWinnerLoading(false);
    }
  };

  return (
    <>
      {errorMessage && (
        <Alert
          message={errorMessage}
          color="error"
          onClose={() => setErrorMessage("")}
        />
      )}
      {showMessage && (
        <Alert
          message={showMessage}
          color="info"
          onClose={() => setShowMessage("")}
        />
      )}
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        className={styles.topTitle}
      >
        <Typography variant="h6">Edit Event</Typography>
        <Button
          variant="text"
          color="primary"
          size="small"
          startIcon={<VisibilityIcon />}
          onClick={() => history.push(Routes.EVENT + "/" + id)}
        >
          Show
        </Button>
      </Grid>
      <div>
        {eventData && (
          <EventForm
            data={eventData}
            formMode="edit"
            onSubmit={onSubmit}
            loading={editloading}
            showWinnerButton={eventData.hasWinners && !eventData.winners?.first}
            onWinnerButton={onWinners}
            eventWinnerLoading={eventWinnerLoading}
          />
        )}
      </div>
    </>
  );
};

export default EditEvent;
